import ApiClient from "@/api/ApiClient.ts";

const state = {};

const mutations = {};

const actions = {
  async getTownsByText(_, paramsToSend) {
    const params = {
      ...paramsToSend,
    };
    try {
      const api = ApiClient();
      let { data } = await api.get("towns/townsByText", { params });
      return data;
    } catch (error) {
      console.error("ERROR en getTownsByText: ", error.message);
      return false;
    }
  },

  async getProvincesByText(_, paramsToSend) {
    const params = {
      ...paramsToSend,
    };
    try {
      const api = ApiClient();
      let { data } = await api.get("towns/provincesByText", { params });
      return data;
    } catch (error) {
      return false;
    }
  },

  async getInfoByCp(_, paramsToSend) {
    const params = {
      ...paramsToSend,
    };
    try {
      const api = ApiClient();
      let { data } = await api.get("towns/getInfoByCp", { params });
      return data;
    } catch (error) {
      return false;
    }
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
